import "./template";
import "./style";
/**
 * @typedef DialogOptions
 * @type {object}
 * @property {string} title
 * @property {string} message
 * @property {"error"|"information"|"warning"} type
 * @property {string[]} buttons
 */

export default class Dialog {
  /**
   * 
   * @param {DialogOptions} options
   */
  constructor(options) {
    options = options || {};
    options.buttons = options.buttons || ["ok"];
    options.type = options.type || "information";
    this.options = options;
  }
  /**
   * @param {DialogOptions} options 
   */


  show() {
    this.close();
    /**
     * @type {HTMLTemplateElement} template
     */

    const template = document.querySelector("#dialog-template");
    const messageNode = document.importNode(template.content, true);
    messageNode.querySelector(".dialog-app").setAttribute("data-dialog-app", "true");
    const titleElement = messageNode.querySelector("[data-model='title']");
    titleElement.textContent = this.options.title;
    titleElement.classList.add(this.options.type);
    messageNode.querySelector("[data-model='message']").textContent = this.options.message;
    const buttonsNode = messageNode.querySelector("[data-model='buttons']");

    for (let button of this.options.buttons) {
      const elem = document.createElement("button");
      elem.classList.add("button");
      elem.classList.add("app_button");
      elem.classList.add("app_inline_button");
      elem.classList.add("dialog-button");
      elem.setAttribute("data-button", button);
      const buttonTitle = document.createElement("div");
      buttonTitle.classList.add("app_button_title");
      buttonTitle.textContent = button;
      elem.appendChild(buttonTitle);
      buttonsNode.appendChild(elem);
    }

    document.body.appendChild(messageNode);
    return new Promise(this.createEvents.bind(this));
  }
  /**
   * 
   * @param {DocumentFragment} messageNode 
   */


  createEvents(resolve) {
    const buttons = document.querySelectorAll("[data-dialog-app] .button");
    const closeAction = this.close;

    for (let x = 0; x < buttons.length; x++) {
      const button = buttons[x];
      const value = button.getAttribute("data-button");
      buttons[x].addEventListener("click", ((value, ev) => {
        resolve(value);
        closeAction();
      }).bind(this, value));
    }
  }

  close() {
    let elements = document.querySelectorAll("[data-dialog-app]");

    for (let x = 0; x < elements.length; x++) {
      let item = elements[x];
      item.parentNode.removeChild(item);
    }
  }

}